import { useEffect, useState, useRef } from "react";

import styles from "./Face2.module.scss";

export default function Face3() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined
  );
  const [paddingLeftAndRight, setPaddingLeftAndRight] = useState<
    number | undefined
  >(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.031 * cardRef.current.clientWidth));
        setLineHeight(0.043 * cardRef.current.clientWidth);
        setLetterSpacing(0.001 * cardRef.current.clientWidth);
        setPaddingLeftAndRight(0.05 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          lineHeight: `${lineHeight}px`,
          letterSpacing: `${letterSpacing}px`,
          padding: `0 ${paddingLeftAndRight}px`,
          textAlign: "justify",
        }}
      >
        <p>&nbsp;&nbsp;&nbsp;&nbsp;Vjera u vječite mijene!</p>
        <p>
          I onda ponovo, dokaz salijevanja i kruženja, djela o pretencioznosti,
          što u vlastitoj grozoti uspijevaju biti oličenje svoga straha. Ja koja
          sudim svemu onom što u sebi ne mogu prestati mrziti. Koliko slojeva
          ukida prozirnost?
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;Ne još, ne sada, til… mreža za sitne mržnje.
        </p>
      </div>
    </div>
  );
}
